// @owners { team: patients-team }
import { useCallback } from 'react';
// eslint-disable-next-line import/no-deprecated
import { fetchNextAvailableDates } from '~shared/actions/nextAvailableDates';
import { usePrescriptionsInCart } from '~shared/features/cart/hooks/usePrescriptionsInCart';
import { useNextAvailableDateAddressId } from '~shared/features/next-available-date/hooks/useNextAvailableDateAddressId';
import { useDispatchShared } from '~shared/store';

export const useFetchNextAvailableDatesForCart = () => {
  const dispatch = useDispatchShared();
  const { prescriptionIDs } = usePrescriptionsInCart();
  const addressID = useNextAvailableDateAddressId();

  return useCallback(
    async (options: { unbundledPrescriptionIDs?: number[]; context?: string } = {}) => {
      await dispatch(
        // eslint-disable-next-line import/no-deprecated
        fetchNextAvailableDates({
          unbundledPrescriptionIDs: options.unbundledPrescriptionIDs,
          bundledPrescriptionIDs: prescriptionIDs,
          addressID,
        }),
      );
    },
    [addressID, dispatch, prescriptionIDs],
  );
};
